var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconLock1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 9.5h-.75V6.75a6.75 6.75 0 0 0-13.5 0V9.5H4.5a2 2 0 0 0-2 2V22a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V11.5a2 2 0 0 0-2-2m-9.5 6a2 2 0 0 1 4 0 2 2 0 0 1-1 1.72v2.28a1 1 0 0 1-2 0v-2.28a2 2 0 0 1-1-1.72M7.75 6.75a4.25 4.25 0 0 1 8.5 0V9a.5.5 0 0 1-.5.5h-7.5a.5.5 0 0 1-.5-.5Z"
})));
export default SvgStreamlineIconLock1;